module.exports = __webpack_public_path__ + "img/open-box.63ac030d.svg";